import { withInstall } from '../../../utils/with-install'
import Polyline from './Polyline.vue'

export const ElAmapPolyline = withInstall(Polyline)
export default ElAmapPolyline
